import { GOOGLE_PLACES_API_BASE_URL } from '@repo/constants';
import ky from 'ky';

export const placesKyClient = ky.create({
  prefix: `${GOOGLE_PLACES_API_BASE_URL}/`,
  hooks: {
    beforeRequest: [
      async ({ request }) => {
        const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;
        if (apiKey) {
          request.headers.set('X-Goog-Api-Key', apiKey);
        }
      },
    ],
  },
});
